<div class="wrapper">
  <div class="summary-wrapper">
    <span class="summary" id="shepherd-installationsView-2">
      <ng-container *ngFor="let link of links">
        <a
          gtm="onGoToPage"
          [gtmAction]="'Installations dashboard, navigate to ' + link.link"
          gtmCategory="installations"
          class="summary__link"
          [routerLink]="link.link"
          routerLinkActive="selected-link"
          [routerLinkActiveOptions]="{ exact: true }"
          [attr.data-at-installations-overview-list]="link.linkID === LinkID.list ? '' : null"
          [attr.data-at-installations-overview-board]="link.linkID === LinkID.board ? '' : null"
          [attr.data-at-installations-overview-map]="link.linkID === LinkID.map ? '' : null"
          (click)="onTabSelection(link.link)"
        >
          <span class="summary__link__text">
            {{ link.label }}
          </span>
        </a>
      </ng-container>
    </span>
  </div>
  <div class="manage" id="shepherd-installationsView-3">
    <div class="filters" data-at-kanban-filters>
      <app-dashboard-filter-input></app-dashboard-filter-input>
      <app-dashboard-filter-list *ngIf="isFilterListVisible"></app-dashboard-filter-list>
    </div>
    <app-refresh-snapshot-button></app-refresh-snapshot-button>
  </div>
</div>
